import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/square'
  },
  {
    path: '/square',
    name: 'square',
    component: () => import(/* webpackChunkName: 'square' */ '@/views/square.vue'),
  },
  {
    path: '/publish',
    name: 'publish',
    component: () => import(/* webpackChunkName: 'square' */ '@/views/publish.vue'),
  },
  {
    path: '/success',
    name: 'success',
    component: () => import(/* webpackChunkName: 'square' */ '@/views/success.vue'),
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: 'square' */ '@/views/detail.vue'),
  },
  {
    path: '/sign',
    name: 'sign',
    component: () => import(/* webpackChunkName: 'square' */ '@/views/sign_up.vue'),
  }
]

const router = new Router({ routes });

export  {
  router
};